import React, { Component } from 'react';
import { t } from '../../../../locales';

import ImageText from '../../../../components/ImageText/';

import Newbie from '../../../../assets/images/vhis/icon--vhis--newbie.png';
import Jade from '../../../../assets/images/vhis/icon--vhis--jade.png';
import Crystal from '../../../../assets/images/vhis/icon--vhis--crystal.png';
import Diamond from '../../../../assets/images/vhis/icon--vhis--diamond.png';

interface VhisRulesProps {
  className?: string;
  ruleType?: 'SH' | 'WGP';
}

class VhisRules extends Component<VhisRulesProps> {
  render() {
    const { className, ruleType } = this.props;

    return (
      <div className={className}>
        {ruleType === 'SH' ? (
          <ImageText imgSrc={Newbie} type="rules">
            <p className="image-text__txt__content image-text__txt__content--small">
              {t('SH_NEWBIE_CONTENT')}
            </p>
          </ImageText>
        ) : (
          <>
            <ImageText imgSrc={Newbie} type="rules">
              <p className="image-text__txt__content image-text__txt__content--small">
                {t('NEWBIE_CONTENT')}
              </p>
            </ImageText>
            <ImageText imgSrc={Crystal} type="rules">
              <p className="image-text__txt__content">
                <b>{t('CRYSTAL_CONTENT_DAYS')}</b>
                <span className="image-text__txt__content--small">
                  /{t('MEMBERSHIP_YEAR')}
                </span>
              </p>
              <p className="image-text__txt__content image-text__txt__content--small">
                {t('CRYSTAL_CONTENT_DISCOUNT')}
              </p>
            </ImageText>

            <ImageText imgSrc={Jade} type="rules">
              <p className="image-text__txt__content">
                <b>{t('JADE_CONTENT_DAYS')}</b>
                <span className="image-text__txt__content--small">
                  /{t('MEMBERSHIP_YEAR')}
                </span>
              </p>
              <p className="image-text__txt__content image-text__txt__content--small">
                {t('JADE_CONTENT_DISCOUNT')}
              </p>
            </ImageText>

            <ImageText imgSrc={Diamond} type="rules">
              <p className="image-text__txt__content">
                <b>{t('DIAMOND_CONTENT_DAYS')}</b>
                <span className="image-text__txt__content--small">
                  /{t('MEMBERSHIP_YEAR')}
                </span>
              </p>
              <p className="image-text__txt__content image-text__txt__content--small">
                {t('DIAMOND_CONTENT_DISCOUNT')}
              </p>
            </ImageText>
          </>
        )}
      </div>
    );
  }
}

export default VhisRules;
